<template>
  <el-form-item label="选择车辆" size="small">
    <el-select v-model="form.car_id" filterable clearable placeholder="请选择车牌" @change="setplateNumber"> <!-- @change="setplateNumber"-->
      <el-option v-for="item in carData" :key="item.id" :label="item.plate_number" :value="item.id"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: "carListTemp",
  props:['carId'],
  data() {
    return {
      carData:[], //车辆列表
      form: {
        car_id:''
      }
    };
  },
  created() {
    this.form.car_id = this.carId
    this.getCarData()
  },
  methods: {
    setplateNumber(value){
      this.carData.forEach(item=>{
        if (item.id === value) {
          ////console.log(item.plate_number) // 打印输出了label、value值 plate_number
          this.$emit('changeData',item)
        }
      })
    },
    getCarData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getCarList(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data.data);
          this.carData = res.data.data
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    }

  },
};
</script>


// WEBPACK FOOTER //
// src/view/common/carlistTemp.vue